export enum ProjectCreateType {
  Blank = 'blank',
  AI = 'customProjectWithAI',
  Template = 'template'
}
